import dynamic from "next/dynamic";

export const CUSTOM_COMPONENTS = {
  RainbowBooks: dynamic(() => import("./RainbowBooks"), {
    ssr: false,
  }),
  MonthlyThemes: dynamic(() => import("./MonthlyThemes")),
  ClubCards: dynamic(() => import("./ClubCards")),
  TestimonialCarousel: dynamic(() => import("./TestimonialCarousel")),
  ConfirmationCard: dynamic(() => import("./ConfirmationCard")),
  Reviews: dynamic(() => import("./Reviews"), { ssr: false }),
  PastBoxesCarousel: dynamic(() => import("./PastBoxesCarousel")),
  BookArrangement1: dynamic(() => import("./BookArrangement1")),
  BoxFeatures: dynamic(() => import("./InsideBox")),
};

export const CustomComponent = (props) => {
  const { entry } = props;
  const componentName = entry.component;

  const Component = CUSTOM_COMPONENTS[componentName];

  if (Component) {
    return <Component {...props} />;
  }
  return null;
};

export default CustomComponent;
